
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Container } from 'react-bootstrap'
import Swal from 'sweetalert2'
import allowNumbersOnly, { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations'
import { ERROR_MSG } from '../../CommonUtils/contextVariables'
import * as Yup from 'yup'
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios'
import { failureAlert } from '../../CommonUtils/SweetAlerts'
import { config } from '../../CommonUtils/CommonURLS'
import * as bie from "react-bootstrap";
import { showCustomAlert } from '../../CommonUtils/CommonServices'

export default function FFCAProgrammeWiseDetails({ name, setIndex, x, onSuccessSubmit }) {
    let LandType = "SqFt/SqMtr";
    const ffacadetailsFormik = useFormik({
        initialValues: {
            qualifiedFaculty: [{
                courseId: "",
                qualifiedFacultyNorms: "",
                qualifiedFacultyAvailable: "",
                qualifiedFacultyDeficiency: "",
            }],
            classRooms: [{
                courseId: "",
                clsroomsDimensions: "",
                clsroomsNos: "",
                clsroomsNorms: "",
                clsroomsAvailable: "",
                clsroomsDeficiency: "",
            }],
            labs: [{
                courseId: "",
                labsDimensions: "",
                labsNos: "",
                labsNorms: "",
                labsAvailable: "",
                labsDeficiency: ""
            }],

            equipment: [{
                courseId: "",
                equipmentAvailable: "",
                equipmentDeficiency: "",
            }],

            amount: "",
            availableBalance: "",
            bankersName: "",
        },
        validationSchema: Yup.object().shape({

            qualifiedFaculty: Yup.array().of(Yup.object().shape({
                qualifiedFacultyNorms: Yup.string().required(ERROR_MSG).nullable(),
                qualifiedFacultyAvailable: Yup.string().required(ERROR_MSG).nullable(),
            })),

            classRooms: Yup.array().of(Yup.object().shape({
                clsroomsDimensions: Yup.string().required(ERROR_MSG).nullable(),
                clsroomsNos: Yup.string().required(ERROR_MSG).nullable(),
                clsroomsNorms: Yup.string().required(ERROR_MSG).nullable(),
                clsroomsAvailable: Yup.string().required(ERROR_MSG).nullable()
            })),
            labs: Yup.array().of(Yup.object().shape({
                labsDimensions: Yup.string().required(ERROR_MSG).nullable(),
                labsNos: Yup.string().required(ERROR_MSG).nullable(),
                labsNorms: Yup.string().required(ERROR_MSG).nullable(),
                labsAvailable: Yup.string().required(ERROR_MSG).nullable()
            })),
            equipment: Yup.array().of(Yup.object().shape({
                equipmentAvailable: Yup.string().required(ERROR_MSG).nullable(),
                equipmentDeficiency: Yup.string().required(ERROR_MSG).nullable()
            })),

            amount: Yup.string().required(ERROR_MSG).nullable(),
            availableBalance: Yup.string().required(ERROR_MSG).nullable(),
            bankersName: Yup.string().required(ERROR_MSG).nullable()

        }),
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}insertfacultydef`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire({
                                text: res?.data?.sdesc,
                                icon: "success",
                                backdrop: true
                            }).then(() => {
                                x();
                                GetFFCAListsData();
                                if (onSuccessSubmit) {
                                    onSuccessSubmit();
                                }
                            });

                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                }
            });
        }
    });


    const handleAvailableChange = (arrayName, normsKey, availableKey, deficiencyKey, label, index, courseId, courseid) => (e) => {
        const available = parseFloat(e.target.value || 0);
        const norms = parseFloat(ffacadetailsFormik.values?.[arrayName]?.[index]?.[normsKey] || 0);

        //   if (available > norms) {
        //     Swal.fire({
        //       icon: "warning",
        //       title: "Invalid Input",
        //       text: `Available ${label} cannot be greater than required as per norms.`,
        //     }).then(() => {
        //       ffacadetailsFormik.setFieldValue(`${arrayName}[${index}].${availableKey}`, "");
        //       ffacadetailsFormik.setFieldValue(`${arrayName}[${index}].${deficiencyKey}`, "");
        //     });
        //     return;
        //   }

        let deficiency = norms - available
        deficiency = deficiency < 0 ? 0 : parseFloat(deficiency.toFixed(4));
        ffacadetailsFormik.setFieldValue(`${arrayName}[${index}].${availableKey}`, e.target.value);
        ffacadetailsFormik.setFieldValue(`${arrayName}[${index}].${deficiencyKey}`, deficiency);
        ffacadetailsFormik.setFieldValue(`${arrayName}[${index}].${courseId}`, courseid);
    };

    const [FfcaCourseDetailsData, setFfcaCourseDetailsData] = useState([]);

    function GetFFCACourseDetailsData() {
        let url = config.url.API_URL + `getafflcoursedtls`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setFfcaCourseDetailsData(res?.data?.data);
                ffacadetailsFormik.setFieldValue('qualifiedFaculty', res?.data?.data.map(() => ({
                    qualifiedFacultyNorms: '',
                    qualifiedFacultyAvailable: '',
                    qualifiedFacultyDeficiency: '',
                })));
                ffacadetailsFormik.setFieldValue('classRooms', res?.data?.data.map(() => ({
                    clsroomsDimensions: "",
                    clsroomsNos: "",
                    clsroomsNorms: "",
                    clsroomsAvailable: "",
                    clsroomsDeficiency: "",
                })));
                ffacadetailsFormik.setFieldValue('labs', res?.data?.data.map(() => ({
                    labsDimensions: "",
                    labsNos: "",
                    labsNorms: "",
                    labsAvailable: "",
                    labsDeficiency: ""
                })));
                ffacadetailsFormik.setFieldValue('equipment', res?.data?.data.map(() => ({
                    equipmentAvailable: "",
                    equipmentDeficiency: "",
                })));
            }
            else {
                setFfcaCourseDetailsData([]);
            }
        })
    }
    const [defData, setDefData] = useState([]);
    function GetFFCAListsData() {
        let url = config.url.API_URL + `getafflfacultydef`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setDefData(res?.data)
                if (res?.data?.facultydetails_status === true) {
                    res?.data?.facultydetails?.forEach((data, i) => {
                        ffacadetailsFormik?.setFieldValue(`qualifiedFaculty[${i}].courseId`, data?.course_id);
                        ffacadetailsFormik?.setFieldValue(`qualifiedFaculty[${i}].qualifiedFacultyNorms`, data?.qualified_faculty_norms ?? "",);
                        ffacadetailsFormik?.setFieldValue(`qualifiedFaculty[${i}].qualifiedFacultyAvailable`, data?.qualified_faculty_available);
                        ffacadetailsFormik?.setFieldValue(`qualifiedFaculty[${i}].qualifiedFacultyDeficiency`, data?.qualified_faculty_deficiency);
                    })
                }
                else {

                }
                if (res?.data?.classroom_status === true) {
                    res?.data?.classroom?.forEach((data, i) => {
                        ffacadetailsFormik?.setFieldValue(`classRooms[${i}].courseId`, data?.course_id);
                        ffacadetailsFormik?.setFieldValue(`classRooms[${i}].clsroomsDimensions`, data?.clsrooms_dimensions ?? "",);
                        ffacadetailsFormik?.setFieldValue(`classRooms[${i}].clsroomsNos`, data?.clsrooms_nos);
                        ffacadetailsFormik?.setFieldValue(`classRooms[${i}].clsroomsNorms`, data?.clsrooms_norms);
                        ffacadetailsFormik?.setFieldValue(`classRooms[${i}].clsroomsAvailable`, data?.clsrooms_available);
                        ffacadetailsFormik?.setFieldValue(`classRooms[${i}].clsroomsDeficiency`, data?.clsrooms_deficiency);
                    })
                }
                else {

                }
                if (res?.data?.labs_status === true) {
                    res?.data?.labs?.forEach((data, i) => {
                        ffacadetailsFormik?.setFieldValue(`labs[${i}].courseId`, data?.course_id);
                        ffacadetailsFormik?.setFieldValue(`labs[${i}].labsDimensions`, data?.labs_dimensions ?? "",);
                        ffacadetailsFormik?.setFieldValue(`labs[${i}].labsNos`, data?.labs_nos);
                        ffacadetailsFormik?.setFieldValue(`labs[${i}].labsNorms`, data?.labs_norms);
                        ffacadetailsFormik?.setFieldValue(`labs[${i}].labsAvailable`, data?.labs_available);
                        ffacadetailsFormik?.setFieldValue(`labs[${i}].labsDeficiency`, data?.labs_deficiency);
                    })
                }
                else {

                }
                if (res?.data?.equipment_status === true) {
                    res?.data?.equipment?.forEach((data, i) => {
                        ffacadetailsFormik?.setFieldValue(`equipment[${i}].courseId`, data?.course_id);
                        ffacadetailsFormik?.setFieldValue(`equipment[${i}].equipmentAvailable`, data?.equipment_available ?? "",);
                        ffacadetailsFormik?.setFieldValue(`equipment[${i}].equipmentDeficiency`, data?.equipment_deficiency);
                    })
                }
                else {

                }
                if (res?.data?.corpus_status === true) {
                    res?.data?.corpus?.forEach((data, i) => {
                        ffacadetailsFormik?.setFieldValue("amount", data?.amount)
                        ffacadetailsFormik?.setFieldValue("availableBalance", data?.available_balance)
                        ffacadetailsFormik?.setFieldValue("bankersName", data?.bankers_name)
                    })
                }
                else {

                }
            }
        })
    }
    useEffect(() => {
        GetFFCACourseDetailsData();
        GetFFCAListsData();
        showCustomAlert();
    }, [name])


    return (
        <div>

            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-3" >
                <FormikProvider value={ffacadetailsFormik}>
                    <Form onSubmit={ffacadetailsFormik.handleSubmit} onChange={ffacadetailsFormik.handleChange}>

                        <bie.Row className='pt-3'>
                            <bie.Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                                <bie.Alert variant="danger" className='affl-alert' >
                                    <p className="mb-0">Note : Please enter area values as follows:<br />
                                        1: APCHE approved courses: Enter in **square feet** (sq.ft).<br />
                                        2: AICTE approved courses: Enter in **square meters** (sq.mtr).<br />
                                    </p>
                                </bie.Alert>
                            </bie.Col>
                        </bie.Row>
                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="">Faculty Details </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Course</th>
                                            <th>Required as per norms </th>
                                            <th>Available</th>
                                            <th>Deficiency</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {FfcaCourseDetailsData !== undefined && FfcaCourseDetailsData?.map((data, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.course_details}</td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`qualifiedFaculty[[${index}].qualifiedFacultyNorms`}

                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                                onChange={() => {
                                                                    ffacadetailsFormik.setFieldValue(`qualifiedFaculty[[${index}].qualifiedFacultyAvailable`, "")
                                                                    ffacadetailsFormik.setFieldValue(`qualifiedFaculty[[${index}].qualifiedFacultyDeficiency`, "")
                                                                }}
                                                            />
                                                            <ErrorMessage name={`qualifiedFaculty[[${index}].qualifiedFacultyNorms`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`qualifiedFaculty[[${index}].qualifiedFacultyAvailable`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                                onChange={handleAvailableChange("qualifiedFaculty", "qualifiedFacultyNorms",
                                                                    "qualifiedFacultyAvailable", "qualifiedFacultyDeficiency", data?.course_details, index, "courseId", data?.course_id)}
                                                            />
                                                            <ErrorMessage name={`qualifiedFaculty[[${index}].qualifiedFacultyAvailable`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name={`qualifiedFaculty[[${index}].qualifiedFacultyDeficiency`} disabled />
                                                        </td>

                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="">Classrooms  </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Course</th>
                                            <th>No of Classrooms</th>
                                            <th>Dimensions ({LandType})</th>
                                            <th>Required as per norms ({LandType})</th>
                                            <th>Available ({LandType})</th>
                                            <th>Deficiency  ({LandType})</th>
                                        </tr>
                                    </thead>


                                    <tbody>
                                        {FfcaCourseDetailsData !== undefined && FfcaCourseDetailsData?.map((data, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.course_details}</td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`classRooms[[${index}].clsroomsNos`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                            />
                                                            <ErrorMessage name={`classRooms[[${index}].clsroomsNos`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`classRooms[[${index}].clsroomsDimensions`}

                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                                onPaste={(e) => { handlePaste(e) }} />
                                                            <ErrorMessage name={`classRooms[[${index}].clsroomsDimensions`} component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`classRooms[[${index}].clsroomsNorms`} onKeyPress={(e) => { AllowFloats(e) }}
                                                                onChange={() => {
                                                                    ffacadetailsFormik.setFieldValue(`classRooms[[${index}].clsroomsAvailable`, "")
                                                                    ffacadetailsFormik.setFieldValue(`classRooms[[${index}].clsroomsDeficiency`, "")
                                                                }}
                                                            />
                                                            <ErrorMessage name={`classRooms[[${index}].clsroomsNorms`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`classRooms[[${index}].clsroomsAvailable`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                                onChange={handleAvailableChange("classRooms", "clsroomsNorms", "clsroomsAvailable",
                                                                    "clsroomsDeficiency", data?.course_details, index, "courseId", data?.course_id)}
                                                            />
                                                            <ErrorMessage name={`classRooms[[${index}].clsroomsAvailable`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name={`classRooms[[${index}].clsroomsDeficiency`} disabled />
                                                        </td>

                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>

                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="">Labs  </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Course</th>
                                            <th>No of Labs</th>
                                            <th>Dimensions ({LandType})</th>
                                            <th>Required as per norms ({LandType})</th>
                                            <th>Available   ({LandType})</th>
                                            <th>Deficiency   ({LandType})</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {FfcaCourseDetailsData !== undefined && FfcaCourseDetailsData?.map((data, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.course_details}</td>
                                                        <td>
                                                            <Field type="text" className="form-control" name={`labs[[${index}].labsNos`}
                                                                onKeyPress={(e) => { allowNumbersOnly(e); }} maxLength="10"
                                                            />
                                                            <ErrorMessage name={`labs[[${index}].labsNos`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name={`labs[[${index}].labsDimensions`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                            />
                                                            <ErrorMessage name={`labs[[${index}].labsDimensions`} component="div" className="text-error" />
                                                        </td>

                                                        <td>
                                                            <Field type="text" className="form-control" name={`labs[[${index}].labsNorms`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                                onChange={() => {
                                                                    ffacadetailsFormik.setFieldValue(`labs[[${index}].labsAvailable`, "")
                                                                    ffacadetailsFormik.setFieldValue(`labs[[${index}].labsDeficiency`, "")
                                                                }}
                                                            />
                                                            <ErrorMessage name={`labs[[${index}].labsNorms`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`labs[[${index}].labsAvailable`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                                onChange={handleAvailableChange("labs", "labsNorms", "labsAvailable",
                                                                    "labsDeficiency", data?.course_details, index, "courseId", data?.course_id)}
                                                            />
                                                            <ErrorMessage name={`labs[[${index}].labsAvailable`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control" name={`labs[[${index}].labsDeficiency`} disabled />
                                                        </td>

                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="">Equipment  </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>S.No</th>
                                            <th>Course</th>
                                            <th>Available with no’s</th>
                                            <th>Deficiency & no’s Item</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {FfcaCourseDetailsData !== undefined && FfcaCourseDetailsData?.map((data, index) => {
                                            return (
                                                <React.Fragment key={index}>
                                                    <tr>
                                                        <td>{index + 1}</td>
                                                        <td style={{ textAlign: "left" }}>{data?.course_details}</td>
                                                        <td>
                                                            <Field type="hidden" className="form-control" name={`equipment[[${index}].courseId`} />
                                                            <Field type="text" className="form-control" name={`equipment[[${index}].equipmentAvailable`}
                                                                onKeyPress={(e) => { AllowFloats(e); }}
                                                            />
                                                            <ErrorMessage name={`equipment[[${index}].equipmentAvailable`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field type="text" className="form-control"
                                                                name={`equipment[[${index}].equipmentDeficiency`}
                                                                onKeyPress={(e) => {
                                                                    AllowFloats(e);
                                                                    ffacadetailsFormik.setFieldValue(`equipment[[${index}].courseId`, data?.course_id)
                                                                }}
                                                            />
                                                            <ErrorMessage name={`equipment[[${index}].equipmentDeficiency`} component="div" className="text-error" />
                                                        </td>


                                                    </tr>
                                                </React.Fragment>
                                            )
                                        })}
                                    </tbody>

                                </table>
                            </div>

                        </div>

                        <div className="px-1">
                            <div className="inner-herbpage-service-title-sub">
                                <h1 className="">Corpus Details  </h1>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-condensed table-bordered table-sm table-responsive table-stripped affl-table affl-table1">
                                    <thead>
                                        <tr>
                                            <th>Particulars</th>
                                            <th>Amount required</th>
                                            <th>Amount available balance</th>
                                            <th>In favor of with Corpus fund No. Bankers Name</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>
                                                Corpus Fund
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="amount"
                                                    onKeyPress={(e) => { AllowFloats(e); }} />
                                                <ErrorMessage name="amount" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="availableBalance"
                                                    onKeyPress={(e) => { AllowFloats(e); }} />
                                                <ErrorMessage name="availableBalance" component="div" className="text-error" />
                                            </td>
                                            <td>
                                                <Field type="text" className="form-control" name="bankersName" maxLength="400" />
                                                <ErrorMessage name="bankersName" component="div" className="text-error" />
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>


                        {defData?.corpus?.length === 0 || defData?.corpus?.length === null || defData?.corpus?.length === undefined || defData?.corpus.length === '' || defData?.corpus === "No data found" ? (<>
                            <button type="submit" className="btn btn-success btn-sm float-end">Submit</button>
                            <br />
                            <br />

                        </>) : (<b className='float-end' style={{ color: "brown", fontSize: "20px" }}>

                            Already Submitted
                        </b>)}
                        < br />
                    </Form>
                </FormikProvider>
            </Container>
        </div >
    )
}
